<template>
  <el-dialog class="map-track" :visible.sync="mapTrackVisible" width="810px" :before-close="handleClose">
    <div v-if="1" class="flex">
      <div class="map" id="container"></div>
      <div class="time-line">
        <div class="time-line-title">查看运输轨迹</div>
        <div class="time-line-list">
          <div
            v-for="(item, index) in listData"
            :key="index"
            class="time-line-item">
            <div style="margin-top: 4px">
              <div
                class="circular-ring"
                :style="{
                  border:
                    index === 0 ? '2px solid #59B9D3' : '2px solid #CCD1DA',
                }"></div>
              <div class="line-between" :style="{ display: index == listData.length - 1 ? 'none' : '' }"></div>
            </div>
            <div style="padding-bottom: 20px">
              <div class="node-status" :style="{ color: index === 0 ? '#59B9D3' : '#4B5563' }">
                {{ item.MilestoneDesc }}
              </div>
              <div class="node-times">{{ item.EventDT }}</div>
              <div class="node-description" :style="{ color: index === 0 ? '#59B9D3' : '#4B5563' }">
                {{ item.Remark }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="text-align:center;min-height: 30vh;margin-top: 12vh;">
      <img style="width:64px;height:64px;display: inline-block;" src="@/assets/tms/not_found_data.png" />
      <div style="font-size: 16px; margin-top: 8px;">暂无数据</div>
    </div>
  </el-dialog>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import { getordertaskmilestonelist } from '@/api/tms'
export default {
  // components: {
  //   AMapLoader
  // },
  props: {
    mapTrackVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listData: [],
      map: {},
      loadAddress: '',
      unloadAddress: ''
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    init (TaskContainerID, TaskID, loadLngLat, unloadLngLat, loadAddress, unloadAddress) {
      if (!TaskContainerID) return
      getordertaskmilestonelist({ TaskContainerID, TaskID }).then((res) => {
        if (!res.Data) return
        this.listData = res.Data.Data || []
        // const coord = this.listData.map((item) => {
        //   return [item.Longitude, item.Latitude]
        // })
        // this.initMap(coord)
      })
      this.loadAddress = loadAddress
      this.unloadAddress = unloadAddress
      this.initMap(loadLngLat, unloadLngLat)
    },
    initMap (loadLngLat, unloadLngLat) {
      AMapLoader.load({
        key: '61ba8ec814dab5090d0528f1e8a9c5a5', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.ToolBar', 'AMap.Driving'] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          var zoom = this.calculateZoom(
            AMap,
            loadLngLat,
            unloadLngLat
          )
          this.map = new AMap.Map('container', {
            // 设置地图容器id
            zoom: zoom // 初始化地图级别
          })

          //   var startMarker = new AMap.Marker({
          //     map: map,
          //     position: coord[coord.length - 1],
          //     autoRotation: true
          //   })
          //   startMarker.setLabel({
          //     direction: 'top',
          //     offset: new AMap.Pixel(0, -6), // 设置文本标注偏移量
          //     content: '装货地点' // 设置文本标注内容
          //   })
          //   var endIcon = new AMap.Icon({
          //     size: new AMap.Size(25, 34),
          //     image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
          //     imageSize: new AMap.Size(135, 40),
          //     imageOffset: new AMap.Pixel(-95, -3)
          //   })
          //   var endMarker = new AMap.Marker({
          //     map: map,
          //     position: coord[0],
          //     // icon: endIcon,
          //     autoRotation: true
          //   })
          //   endMarker.setLabel({
          //     direction: 'top',
          //     offset: new AMap.Pixel(0, -6), // 设置文本标注偏移量
          //     content: '卸货地点' // 设置文本标注内容
          //   })
          var drivingOption = {
            policy: AMap.DrivingPolicy.LEAST_TIME // 其它policy参数请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingPolicy
          }

          // 构造路线导航类
          var driving = new AMap.Driving(drivingOption)
          const _this = this
          // 根据起终点经纬度规划驾车导航路线
          driving.search(new AMap.LngLat(loadLngLat[0], loadLngLat[1]), new AMap.LngLat(unloadLngLat[0], unloadLngLat[1]), function(status, result) {
            // result即是对应的驾车导航信息，相关数据结构文档请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
            if (status === 'complete') {
              if (result.routes && result.routes.length) {
                // 绘制第一条路线，也可以按需求绘制其它几条路线
                _this.drawRoute(result.routes[0], AMap)
              }
            } else {
            }
          })
          //   map.addControl(new AMap.ToolBar())

          //   coord.reverse()
          // 绘制轨迹
          //   var polyline = new AMap.Polyline({
          //     map: map,
          //     path: coord,
          //     showDir: true, // 是否显示箭头false/true
          //     strokeColor: '#59b9d3', // 线颜色
          //     strokeOpacity: 1, // 画线透明度
          //     strokeWeight: 6, // 线宽
          //     strokeStyle: 'solid' // 线样式,实线"solid"/虚线"dashed"
          //   })
        //   map.add(endMarker)
        //   map.add(startMarker)
        })
        .catch((e) => {
          console.log(e)
        })
    },
    parseRouteToPath(route) {
      var path = []

      for (var i = 0, l = route.steps.length; i < l; i++) {
        var step = route.steps[i]

        for (var j = 0, n = step.path.length; j < n; j++) {
          path.push(step.path[j])
        }
      }

      return path
    },
    drawRoute (route, AMap) {
      var path = this.parseRouteToPath(route)
      var startMarker = new AMap.Marker({
        position: path[0],
        map: this.map
      })
      startMarker.setLabel({
        direction: 'top',
        offset: new AMap.Pixel(0, -6), // 设置文本标注偏移量
        content: '装货地点：' + this.loadAddress // 设置文本标注内容
      })
      var endMarker = new AMap.Marker({
        position: path[path.length - 1],
        map: this.map
      })
      endMarker.setLabel({
        direction: 'top',
        offset: new AMap.Pixel(0, -6), // 设置文本标注偏移量
        content: '卸货地点：' + this.unloadAddress// 设置文本标注内容
      })

      var routeLine = new AMap.Polyline({
        path: path,
        isOutline: true,
        showDir: true,
        strokeColor: '#59b9d3',
        strokeWeight: 5,
        strokeStyle: 'solid'
      })

      routeLine.setMap(this.map)

      // 调整视野达到最佳显示区域
      this.map.setFitView([startMarker, endMarker, routeLine])
    },
    // 根据起始位置判断地图容器缩放等级
    calculateZoom (AMap, start, end) {
      var distance = AMap.GeometryUtil.distance(
        [start[0], start[1]],
        [end[0], end[1]]
      ) // 以高德提供的方法来获取两点间的距离
      var nowDivLine = Math.sqrt(450 * 450 + 512 * 512) // 求出地图容器的对角线长度
      var nowScale = distance / nowDivLine // 求出覆盖物范围和地图容器的比例
      var nowNum = 16 - Math.ceil(Math.log(nowScale) / Math.log(2)) // 求出可以显示出所有覆盖物的级别
      return nowNum > 12 ? 12 : nowNum
    }
  }
}
</script>
<style lang="less">
.map-track {
  .el-dialog__headerbtn {
    top: 12px;
    right: 14px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 20px;
  }
  .map {
    width: 450px;
    height: 512px;
  }
  .time-line {
    width: 300px;
    margin-left: 20px;
    margin-top: 18px;
    .time-line-title {
      height: 32px;
      background: #f6f6f8;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      color: #111827;
      padding-left: 11px;
      line-height: 32px;
    }
    .time-line-list {
      margin-top: 14px;
      height: 452px;
      overflow-y: scroll;
    }
    .time-line-item {
      display: flex;
      justify-content: flex-start;
      padding-right: 12px;
      .circular-ring {
        width: 9px;
        height: 9px;
        margin-right: 13px;
        background-color: #ffffff;
        border-radius: 50%;
      }
      .line-between {
        width: 1px;
        background: #ccd1da;
        height: 100%;
        margin-left: 4px;
      }
      .node-status {
        font-size: 14px;
        font-weight: 500;
        color: #4b5563;
      }
      .node-times {
        font-size: 10px;
        margin-top: 3px;
        font-weight: 400;
        color: #9ca3af;
      }
      .node-description {
        font-size: 12px;
        margin-top: 6px;
        font-weight: 400;
        color: #4b5563;
      }
    }
  }
  .amap-marker-label {
    padding:6px !important;
    box-shadow: 0 2px 6px 0 #33ddec !important;
    border-radius: 4px;
    border:none;
    width: 156px;
    overflow: hidden;
    line-height: 16px;
    white-space: break-spaces;
  }
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
  }
  ::-webkit-scrollbar-track {
    background-color: #f6f6f6;
  }
  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track-piece {
    border: 0;
    background-color: transparent !important;
  }
}
</style>
